import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { toast } from 'sonner';
import { api } from '@/lib/api';
import { Card, CardContent } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';
import { Zap, ArrowLeft, Send, CheckCircle2, KeyRound } from 'lucide-react';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [sent, setSent] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!email.trim()) return;
    setSubmitting(true);
    try {
      await api.forgotPassword(email.trim());
      setSent(true);
      toast.success('Richiesta inviata');
    } catch (err) {
      // Endpoint anti-enumeration ritorna comunque 200; qui gestiamo solo errori di rete
      toast.error('Impossibile contattare il server. Riprova tra qualche istante.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="min-h-screen grid place-items-center bg-background p-6">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-2 mb-6">
          <div className="size-9 rounded-xl bg-primary text-primary-foreground grid place-items-center"><Zap className="size-5" /></div>
          <div className="font-heading text-lg font-semibold">CRM Utility Boost</div>
        </div>
        <h2 className="font-heading text-2xl font-semibold mb-1 flex items-center gap-2"><KeyRound className="size-5 text-primary" />Recupero password</h2>
        <p className="text-sm text-muted-foreground mb-6">Inserisci l&apos;email del tuo account: ti invieremo un link per impostare una nuova password.</p>

        <Card>
          <CardContent className="p-5">
            {sent ? (
              <Alert data-testid="forgot-success-alert">
                <CheckCircle2 className="size-4 text-primary" />
                <AlertTitle>Controlla la tua casella email</AlertTitle>
                <AlertDescription>
                  Se l&apos;email è registrata nel sistema, riceverai a breve un link per il ripristino della password. Il link è valido 30 minuti. Ricorda di controllare anche la cartella spam.
                </AlertDescription>
              </Alert>
            ) : (
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="space-y-1.5">
                  <Label htmlFor="forgot-email">Email</Label>
                  <Input
                    id="forgot-email"
                    type="email"
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    autoComplete="username"
                    required
                    placeholder="nome@azienda.it"
                    data-testid="forgot-email-input"
                  />
                </div>
                <Button type="submit" className="w-full" disabled={submitting} data-testid="forgot-submit-button">
                  <Send className="size-4 mr-1" />{submitting ? 'Invio in corso...' : 'Invia link di ripristino'}
                </Button>
              </form>
            )}
          </CardContent>
        </Card>

        <div className="text-sm text-center mt-6">
          <Link to="/login" className="text-muted-foreground hover:text-foreground inline-flex items-center gap-1" data-testid="forgot-back-to-login">
            <ArrowLeft className="size-3.5" />Torna al login
          </Link>
        </div>
      </div>
    </div>
  );
}
